import { useEffect } from 'react';

export function useTelegramBackButton(shouldShow: boolean, onBack: () => void) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const tg = window?.Telegram?.WebApp;

    if (!tg || !tg.BackButton) return;

    if (shouldShow) {
      tg.BackButton.show();
      tg.BackButton.onClick(onBack);

      return () => {
        tg.BackButton.offClick(onBack);
        tg.BackButton.hide();
      };
    } else {
      tg.BackButton.hide();
    }
  }, [shouldShow, onBack]);
}
